import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ButtonsModule } from 'ngx-bootstrap/buttons';

import { MainComponent } from './main/main.component';

import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LogoComponent } from './logo/logo.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { PageBreadcrumbComponent } from './page-breadcrumb/page-breadcrumb.component';
import { PageHeadingComponent } from './page-heading/page-heading.component';
import { PageFooterComponent } from './page-footer/page-footer.component';
import { DropdownAppsComponent } from './dropdown-apps/dropdown-apps.component';
import { SettingsComponent } from './settings/settings.component';
import { SettingsModalComponent } from './settings-modal/settings-modal.component';
import { SettingsShortcutComponent } from './settings-shortcut/settings-shortcut.component';
import { ShortcutModalComponent } from './shortcut-modal/shortcut-modal.component';
import { FabShortcutComponent } from './fab-shortcut/fab-shortcut.component';
import { DropdownUserComponent } from './dropdown-user/dropdown-user.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { UiModule } from 'src/app/libs/ui/ui.module';
import { NavigationModule } from '../shared/navigation/navigation.module';
import { NzSelectModule } from 'ng-zorro-antd/select';
@NgModule({
  declarations: [
    MainComponent,
    SidebarComponent,
    LogoComponent,
    PageHeaderComponent,
    PageBreadcrumbComponent,
    PageHeadingComponent,
    PageFooterComponent,
    DropdownAppsComponent,
    SettingsComponent,
    SettingsModalComponent,
    SettingsShortcutComponent,
    ShortcutModalComponent,
    FabShortcutComponent,
    DropdownUserComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    BsDropdownModule,
    ModalModule,
    ButtonsModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    // tslint:disable-next-line:max-line-length
    TranslateModule.forChild(), // allways add it for lazy loaded modules https://github.com/ngx-translate/core#1-import-the-translatemodule

    NavigationModule,
    UiModule
  ],
  exports: [MainComponent, SidebarComponent],
})
export class LayoutModule { }
